import {useCallback} from 'react'

export function useUsage(): (eventName: string, eventData?: Record<string, string | number>) => void {
  return useCallback((eventName: string, eventData?: Record<string, string | number>): void => {
    window.umami?.track(eventName, eventData)
  }, [])
}
